import { __require as requireDefineDataProperty } from '../define-data-property/index.js';
import { __require as requireHasPropertyDescriptors } from '../has-property-descriptors/index.js';
import { __require as requireFunctionsHaveNames } from '../functions-have-names/index.js';
import { __require as requireType } from '../es-errors/type.js';

var setFunctionName;
var hasRequiredSetFunctionName;

function requireSetFunctionName () {
	if (hasRequiredSetFunctionName) return setFunctionName;
	hasRequiredSetFunctionName = 1;

	var define = /*@__PURE__*/ requireDefineDataProperty();
	var hasDescriptors = /*@__PURE__*/ requireHasPropertyDescriptors()();
	var functionsHaveConfigurableNames = requireFunctionsHaveNames().functionsHaveConfigurableNames();

	var $TypeError = /*@__PURE__*/ requireType();

	/** @type {import('.')} */
	setFunctionName = function setFunctionName(fn, name) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		var loose = arguments.length > 2 && !!arguments[2];
		if (!loose || functionsHaveConfigurableNames) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
			}
		}
		return fn;
	};
	return setFunctionName;
}

export { requireSetFunctionName as __require };
